/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../_chunks/dep-b011b919.mjs';
import { defineComponent, computed, createVNode } from 'vue';
import { usePrefixClass } from '../../hooks/useConfig.mjs';
import { useTNodeJSX } from '../../hooks/tnode.mjs';
import '../../_chunks/dep-ae1abe1d.mjs';
import '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-8d19eb1a.mjs';
import '../../_chunks/dep-eba62589.mjs';
import '../../_chunks/dep-7d9e11c8.mjs';
import '../../_chunks/dep-16e2f1a5.mjs';
import '../../_chunks/dep-adebe2ce.mjs';
import '../../_chunks/dep-bd3d75f1.mjs';
import '../../_chunks/dep-2b8d75e2.mjs';
import '../../_chunks/dep-8f44163a.mjs';
import '../../_chunks/dep-a255de71.mjs';
import '../../_chunks/dep-ebe8bc2f.mjs';
import '../../_chunks/dep-cc371884.mjs';
import '../../_chunks/dep-1f0070bb.mjs';
import '../../_chunks/dep-9d0d32fd.mjs';
import '../../_chunks/dep-ebfafd52.mjs';
import '../../_chunks/dep-a6022780.mjs';
import '../../_chunks/dep-b9567f6a.mjs';
import '../../_chunks/dep-654b4b01.mjs';
import '../../_chunks/dep-a11a63ea.mjs';
import '../../_chunks/dep-750294df.mjs';
import '../../_chunks/dep-ad1accf9.mjs';
import '../../_chunks/dep-e05e20e6.mjs';
import '../../_chunks/dep-3e3494dc.mjs';
import '../../_chunks/dep-42be3824.mjs';
import '../../_chunks/dep-67dfe9c7.mjs';
import '../../_chunks/dep-7f2f03b4.mjs';
import '../../_chunks/dep-a0bd2e3a.mjs';
import '../../_chunks/dep-91208ac3.mjs';
import '../../_chunks/dep-1041f7d7.mjs';
import '../../_chunks/dep-b32fb318.mjs';
import '../../_chunks/dep-9b57842b.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../_chunks/dep-99a0abba.mjs';
import '../../_chunks/dep-9d5ee0e1.mjs';
import '../../config-provider/type.mjs';
import '../../_chunks/dep-f50ac97c.mjs';
import '../../_chunks/dep-94585de3.mjs';
import '../../_chunks/dep-06221fe2.mjs';
import '../../_chunks/dep-d7053a2c.mjs';
import '../../_chunks/dep-f3e3393e.mjs';
import '../../_chunks/dep-0fa7026c.mjs';
import '../../_chunks/dep-31dc9d09.mjs';
import '../../_chunks/dep-b9d74a58.mjs';
import '../../utils/render-tnode.mjs';
import '../../_chunks/dep-ff1c0573.mjs';

var TImageViewerIcon = defineComponent({
  name: "TImageModalIcon",
  props: {
    disabled: Boolean,
    onClick: Function,
    label: String,
    icon: Function
  },
  setup: function setup(props) {
    var classPrefix = usePrefixClass();
    var renderTNodeJSX = useTNodeJSX();
    var wrapClass = computed(function () {
      return ["".concat(classPrefix.value, "-image-viewer__modal-icon"), _defineProperty({}, "".concat(classPrefix.value, "-is-disabled"), props.disabled)];
    });
    return function () {
      return createVNode("div", {
        "class": wrapClass.value,
        "onClick": props.onClick
      }, [renderTNodeJSX("icon"), props.label && createVNode("span", {
        "class": "".concat(classPrefix.value, "-image-viewer__modal-icon-label")
      }, [props.label])]);
    };
  }
});

export { TImageViewerIcon as default };
//# sourceMappingURL=ImageModalIcon.mjs.map
